export default "__VITE_PUBLIC_ASSET__a01fc9e4__"